import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { getCookie } from '../../../../../utils/getCookies';
import { environment } from '../../../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { ColumnMode, NgxDatatableModule } from '@swimlane/ngx-datatable';
import { TranslateModule } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SocketService } from '../../../../../services/socket.service';
import { ModalGeneralComponent } from '../../../../user/modals/modal-general/modal-general.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalMoreInfoComponent } from './modal-more-info/modal-more-info.component';

@Component({
  selector: 'app-analyzer',
  standalone: true,
  imports: [CommonModule, MatButtonModule, NgxDatatableModule, TranslateModule],
  templateUrl: './analyzer.component.html',
  styleUrl: './analyzer.component.scss'
})
export class AnalyzerComponent implements OnInit{


  @Output() reinit_cv_list: EventEmitter<void> = new EventEmitter<void>();

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      // if we have the id of the analysis, we load the analysis
      if (params['id_analysis'] || localStorage.getItem('conectio_client_id_analysis')) {
        if (this.id_analysis !== (params['id_analysis'] || localStorage.getItem('conectio_client_id_analysis'))) {
            this.id_analysis = params['id_analysis'] || localStorage.getItem('conectio_client_id_analysis') || '';
            this.loadAnalysis(this.id_analysis);
        }
      }
      else {
        this.router.navigate(['/dashboard/company/cv-deep-analyzer']);
      }
    });
  }

  constructor(private http: HttpClient, private route: ActivatedRoute, private socketService: SocketService, private dialog: MatDialog, private router: Router) {


    this.socketService.onCVDeepAnalyzerPreprocessingCompleted((data: any) => {
      this.loading_analysis_rows = false;

      if (data.rows) {

        let sortedData: {[key: string]: any[]} = {};
        for (const jobOfferName in data.rows) {
          const rows = data.rows[jobOfferName];
          // we sort the list by the cscore

          //Calcualte UpdatedCscore
          for (const row of rows) {
            row.cscore_updated = this.calculateCscore(row, jobOfferName);
          }
          sortedData[jobOfferName] = rows.sort((a: any, b: any) => b.cscore_updated - a.cscore_updated);
        }


        this.data_analysis = sortedData;
      }
    });

    this.socketService.onCVDeepAnalyzerPreprocessing((data: any) => {

      const jobOfferName = data.jobOfferName;
      let row: any = data.row;
      row["status"] = data.status;

      // if the jobOfferName is not in the data_analysis, we add it as a new key
      if (!this.data_analysis[jobOfferName]) {
        this.data_analysis[jobOfferName] = [row];
      } else {
        // if it is, we need to see if the row is already in the data_analysis[jobOfferName] or not. If it is, we need to update the row. If it is not, we need to add the row.
        const index = this.data_analysis[jobOfferName].findIndex((r: any) => r.id_analysis === row.id_analysis);
        if (index !== -1) {
          this.data_analysis[jobOfferName][index] = row;
          this.data_analysis[jobOfferName][index].cscore_updated = this.calculateCscore(row, jobOfferName);
          this.data_analysis[jobOfferName] = this.data_analysis[jobOfferName].sort((a: any, b: any) => b.cscore_updated - a.cscore_updated);
        } else {
          // we sort the list by the cscore
          row.cscore_updated = this.calculateCscore(row, jobOfferName);
          this.data_analysis[jobOfferName].push(row);
          this.data_analysis[jobOfferName] = this.data_analysis[jobOfferName].sort((a: any, b: any) => b.cscore_updated - a.cscore_updated);
        }
      }
    });


    this.socketService.onCVDeepAnalyzerFinalReport((data: any) => {
      const jobOfferName = data.job_offer_name;
      const report = data.report;

      // if the jobOfferName is not in the data_analysis, we add it as a new key
      if (!this.data_analysis[jobOfferName]) {
        return;
      } else {

        const index = this.data_analysis[jobOfferName].findIndex((r: any) => r.id_analysis === data.id_analysis);
        if (index !== -1) {
          this.data_analysis[jobOfferName][index].final_report = report;
        } else {
          return;
        }

        // Update the report in place for instant UI update
        this.data_analysis = {
          ...this.data_analysis,
          [jobOfferName]: this.data_analysis[jobOfferName].map((r: any, i: number) => 
            i === index ? { ...r, final_report: report } : r
          )
        };
      }
    });
  }

  // variables for the datatable
  profiles: any[] = [];
  columnModeSetting = ColumnMode.force;
  selected: any[] = [];
  scrollBarHorizontal = true;
  id_analysis: string = '';
  id_company: number = 0;
  total_CVs: number = 0;
  total_JobOffers: number = 0;
  data_analysis: {[key: string]: any} = {};
  base_url: string = environment.url;
  started_editing_analysis_name: boolean = false;
  language: string = 'es'; // Default language
  data_job_offers: {[key: string]: string | any[] | any} = {};
  loading_analysis_rows: boolean = false;
  // preferences dropdown
  showPreferencesPanel = false;
  preferences:{[key: string]: number} = {};
  showPreferencesPanelfilters: boolean = false;


  loading_analysis: boolean = false;
  // function to load the analysis
  loadAnalysis(id_analysis: string) {

    if (this.loading_analysis) return;

    this.loading_analysis = true;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${getCookie('access_token')}`
    });

    this.http.get(`${environment.url}/api/v1/CVDeepAnalyzer/analyzer/get_analysis_data`, { params: { id_analysis: id_analysis }, headers: headers }).subscribe((res: any) => {
      this.loading_analysis = false;
      // we set the total of CVs and job offers
      this.total_CVs = res.totalCVs;
      this.total_JobOffers = res.totalJobOffers;
      this.id_company = res.id_company;
      this.data_job_offers = res.jobOffersJson;

      // we set the preferences from the analysis data
      this.preferences = res.ponderations_params ?? {"experience_score": 80, "skills_score": 10, "language_score": 10, "max_distance": 100, "lang_required": false};
      // we set the language from the analysis data
      this.language = res.language || 'es';

      // we set the job offers names
      const jobOffersNames = res.jobOffersNames;
      
      for (const jobOfferName of jobOffersNames) {
        this.data_analysis[jobOfferName] = [];
      }

      // we call to get the analysis rows
      this.getAnalysisRows();

      this.socketService.updateNewAnalysis({
        id_analysis: this.id_analysis,
        id_company: this.id_company,
        language: this.language
      });
    });
  }

  // function to get the analysis rows
  getAnalysisRows() {
    this.loading_analysis_rows = true;
    this.socketService.getAllAnalysisRows({
      id_analysis: this.id_analysis,
      id_company: this.id_company,
      language: this.language
    });
  }


  openGeneralModal(data: any) {
    ModalGeneralComponent.open(this.dialog, data);
  }

  openLinkedin(linkedin_url: string) {
    window.open(linkedin_url, '_blank');
  }

  openCV(CV_url: string) {
    window.open(this.base_url + '/' + CV_url, '_blank');
  }

  togglePreferencesPanel(): void {
    this.showPreferencesPanel = !this.showPreferencesPanel;
  }

  togglePreferencesPanelFilters(): void {
    this.showPreferencesPanelfilters = !this.showPreferencesPanelfilters;
  }

  updatePreferenceValue(preferenceKey: string, event: Event): void {
    const value = Number((event.target as HTMLInputElement).value);
    this.preferences[preferenceKey] = value;
  }

  loading_save_preferences: boolean = false;
  savePreferencesData() {
    this.loading_save_preferences = true;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${getCookie('access_token')}`
    });
    this.http.post(`${environment.url}/api/v1/CVDeepAnalyzer/analyzer/set_ponderations_parameters`, { ponderations_params: this.preferences, id_analysis: this.id_analysis }, { headers: headers }).subscribe((res: any) => {
      this.loading_save_preferences = false;

      // we modify the cscore
      this.modifyCscore();

      
    }, (error: any) => {
      console.error('Error saving preferences', error);
      this.loading_save_preferences = false;
    });
  }

  modifyCscore(): void {
    // we need to update the ponderation of the Cscore algorithm
    for (const jobOfferName of Object.keys(this.data_analysis)) {
      for (const row of this.data_analysis[jobOfferName]) {
        
        // we need to see the partial score of the job offer
        const partialScore = row?.partial_score;

        if (partialScore) {
          // we need to update the partial score of the job offer
          if (row.cscore !== 'not-identified'){
            row.cscore = this.calculateCscore(row, jobOfferName);
          }
        }
      }
    }

    // we then sort the data_analysis by the cscore
    for (const jobOfferName of Object.keys(this.data_analysis)) {
      this.data_analysis[jobOfferName] = this.orderByCscore(this.data_analysis[jobOfferName]);
    }
  }


  calculateCscore(row: any, jobOfferName: string) {
    const experiencePonderation: number = this.preferences['experience_score'] || 0;
    const skillsPonderation: number = this.preferences['skills_score'] || 0;
    const languagesPonderation: number = this.preferences['language_score'] || 0;
    const partialScore = row.partial_score;

    // calculate if the languages are required
    const languagesRequired = this.calculateLanguagesRequired(partialScore, jobOfferName);
    const maxDistance = this.calculateMaxDistance(row);
    return Math.min(100, Math.round(partialScore.experience_score * (experiencePonderation) + partialScore.skills_score * (skillsPonderation) + partialScore.language_score * (languagesPonderation)) * languagesRequired * maxDistance);
  }

  updatePreferenceValuefilters(preferenceKey: string, event: Event): void {
    const value = Number((event.target as HTMLInputElement).value);
    this.preferences[preferenceKey] = value;
  }



  disableLanguagesRequired(event: any): any {
    const value = (event.target as HTMLInputElement).checked;
    if (value) {
      this.preferences['lang_required'] = 1;
    } else {
      this.preferences['lang_required'] = 0;
    }
  }

  setMaxDistance(event: any): any {
    const value = Number((event.target as HTMLInputElement).value);
    this.preferences['max_distance'] = value;
  }


  calculateLanguagesRequired(partial_score: any, jobOfferName: string): number {

    if (this.preferences['lang_required'] === 1) {

      // we get the languages required from the job offer
      const languages_required = this.data_job_offers[jobOfferName].languages.filter((language: any) => language.mandatory === "required").length;
      const partial_score_required = partial_score?.language_evaluation?.required ?? [];

      // we check if the languages required are met
      if (partial_score_required.length < languages_required) {
        return 0;
      } else {
        return 1;
      }
    } else {
      return 1;
    }
  }


  calculateMaxDistance(row: any): number {
    const max_distance = this.preferences['max_distance'];
    const distance = row.location_data?.distance?.value / 1000;
    if (distance > max_distance) {
      return 0;
    } else {
      return 1;
    }
  }


  orderByCscore(data: any): any {
    return data.sort((a: any, b: any) => (b.cscore !== 'not-identified' ? b.cscore : 0) - (a.cscore !== 'not-identified' ? a.cscore : 0));
  }

  openModalMoreInfo(row: any) {
    //console.log(row);
    ModalMoreInfoComponent.open(this.dialog, { id_analysis_result: row.id_analysis });
  }

}
